import { HttpMethods, makeRequest } from '../helpers/http.helper';
import {
  RegisterPlayerRequest,
  CreateNotificationRequest,
  CreateMultipleNotificationsRequest,
  GetNotificationsParams,
} from '../types/notification.type';

export const registerPlayer = (data: RegisterPlayerRequest) => {
  return makeRequest({
    url: '/notification/register-player',
    method: HttpMethods.POST,
    data,
  });
};

export const unregisterPlayer = (playerId: string) => {
  return makeRequest({
    url: `/notification/unregister-player/${playerId}`,
    method: HttpMethods.POST,
  });
};

export const getNotifications = (
  organizationId: string,
  params?: GetNotificationsParams
) => {
  const queryParams: Record<string, string> = {};
  
  if (params?.limit) {
    queryParams.limit = params.limit.toString();
  }
  if (params?.before_message_id) {
    queryParams.before_message_id = params.before_message_id;
  }
  if (params?.after_message_id) {
    queryParams.after_message_id = params.after_message_id;
  }

  return makeRequest({
    url: `/notification/${organizationId}`,
    method: HttpMethods.GET,
    params: queryParams,
  });
};

export const markNotificationAsRead = (
  organizationId: string,
  notificationId: string
) => {
  return makeRequest({
    url: `/notification/${organizationId}/${notificationId}/read`,
    method: HttpMethods.PUT,
  });
};

export const createNotification = (data: CreateNotificationRequest) => {
  return makeRequest({
    url: '/notification',
    method: HttpMethods.POST,
    data,
  });
};

export const createMultipleNotifications = (
  data: CreateMultipleNotificationsRequest
) => {
  return makeRequest({
    url: '/notification/users',
    method: HttpMethods.POST,
    data,
  });
};

